import DOMPurify from "dompurify";

/**
 * Landing instructions are admin-authored HTML rendered into an anonymous page, so they are
 * sanitized at render rather than trusted from the column. The allowlist covers what
 * TipTapEditor can emit plus the media tags whose src the server rewrites to signed S3 URLs.
 */
const ALLOWED_TAGS = [
  "p", "br", "hr", "span", "div",
  "strong", "b", "em", "i", "u", "s",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "ul", "ol", "li", "blockquote", "pre", "code",
  "table", "thead", "tbody", "tr", "th", "td",
  "a", "img", "video", "iframe", "source",
];

const ALLOWED_ATTR = [
  "href", "target", "rel", "title",
  "src", "alt", "width", "height",
  "controls", "poster", "allowfullscreen",
  "class", "style", "colspan", "rowspan",
  "sandbox", "referrerpolicy",
];

let hooksRegistered = false;

const registerHooks = () => {
  if (hooksRegistered) {
    return;
  }
  hooksRegistered = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "IFRAME") {
      node.setAttribute("sandbox", "allow-scripts allow-same-origin");
      node.setAttribute("referrerpolicy", "no-referrer");
    }
    if (!["IFRAME", "VIDEO", "IMG", "SOURCE"].includes(node.tagName)) {
      return;
    }
    const src = node.getAttribute("src");
    if (src && !/^https:\/\/[\w.-]+\.amazonaws\.com\//i.test(src)) {
      node.removeAttribute("src");
    }
  });
};

export const sanitizeLandingHtml = (html: string | null | undefined): string => {
  registerHooks();
  return DOMPurify.sanitize(html ?? "", {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_ATTR: ["srcdoc", "formaction", "form"],
  });
};
